import type { RouteObject } from "react-router-dom";
import ScrollToTop from "@/components/base/ScrollToTop";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import ArticlePage from "@/pages/article/page";
import AboutPage from "@/pages/about/page";

function WithScrollToTop({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ScrollToTop />
      {children}
    </>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <WithScrollToTop>
        <Home />
      </WithScrollToTop>
    ),
  },
  {
    path: "/category/:categoryId",
    element: (
      <WithScrollToTop>
        <CategoryPage />
      </WithScrollToTop>
    ),
  },
  {
    path: "/article/:id",
    element: (
      <WithScrollToTop>
        <ArticlePage />
      </WithScrollToTop>
    ),
  },
  {
    path: "/about",
    element: (
      <WithScrollToTop>
        <AboutPage />
      </WithScrollToTop>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;